/** Angular Imports */
import { NgModule } from '@angular/core';
import {MatSortModule} from '@angular/material/sort';

/** Custom Modules */
import { SharedModule } from '../shared/shared.module';
import { CashierTransactionsRoutingModule } from './cashier-transactions-routing.module';

/** Custom Components */
import { CashierTransactionsComponent } from './cashier-transactions.component';


@NgModule({
    declarations: [CashierTransactionsComponent],
    imports: [
      SharedModule,
      CashierTransactionsRoutingModule
    ]
  })
export class CashierTransactionsModule { }